<template>
  <div>
    <popup-chat-toast
      v-if="!isChatOpen && !hasToastBeenShown"
      :message="t('chat.greeting')"
      :show-after="3000"
      :auto-hide-after="10000"
      @close="hasToastBeenShown = true"
    />

    <popup-chat-toggle-button
      v-if="!isChatOpen || !isMobile"
      :is-open="isChatOpen"
      data-cy="chat-toggle-button"
      @toggle="toggleChat"
    />

    <div class="chat-window-wrapper">
      <Transition :name="isMobile ? 'slide-up' : 'slide-in'">
        <div
          v-if="isChatOpen"
          class="z-50"
          :class="[
            'chat-window-container',
            isMobile ? 'fixed inset-0' : 'fixed right-4 bottom-20 h-[70vh] w-120 shadow-md',
          ]"
        >
          <popup-chat-window @close="isChatOpen = false" />
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import PopupChatWindow from "@/components/chat/popup/PopupChatWindow.vue";
import PopupChatToggleButton from "@/components/chat/popup/PopupChatToggleButton.vue";
import PopupChatToast from "@/components/chat/popup/PopupChatToast.vue";
import { useResponsive } from "@/composables/common";

const { t } = useI18n();
const { isMobile } = useResponsive();

const isChatOpen = ref(false);
const hasToastBeenShown = ref(false);

const toggleChat = async () => {
  isChatOpen.value = !isChatOpen.value;
};
</script>

<style scoped>
@reference "@/tailwind.css";

.chat-window-wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  pointer-events: none;
  z-index: 40;
}

.chat-window-container {
  pointer-events: auto;
  will-change: transform, opacity;
  transform-origin: bottom right;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
  backface-visibility: hidden;
}

.slide-in-enter-from,
.slide-in-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
